import Button from "components/button";
import { parseFloatByLocale } from "locales/utils";
import Dialog from "material-ui/Dialog";
import PropTypes from "prop-types";
import { Component } from "react";
import intl from "react-intl-universal";
import { formatOnlyNumber } from "utils/format";
import MaterialSupplierFormContent from "./components/material-supplier-form-content";
import StyledMaterialSupplierForm from "./material-supplier-form.styled";
import { supplierOrigin, supplierValues } from "./supplier-utils";

const RESPONSAVEL_ENTREGA_CIF = 1;
const RESPONSAVEL_ENTREGA_FOB = 2;

class MaterialSupplierForm extends Component {
  constructor(props) {
    super();
    this.state = {
      origemMaterial: supplierValues.COMPRA_DE_INSUMOS,
      idLabeledFamilyCenter: props.idLabeledFamilyCenter,
      materialSupplier: {
        IdFornecedor: 0,
        Fornecedor: {},
        Nome: "",
        ResponsavelEntrega: RESPONSAVEL_ENTREGA_CIF,
        QuebraEntrega: 0,
        Arredondamento: 0,
        LoteMinimo: 0,
        SLA: 0,
        TransitTime: 0,
        Leadtime: 0,
        PortToDoorTransitTime: "0",
        Tipo: 0,
        OrganizacaoCompras: "",
        GrupoCompradores: "",
        CodigoImposto: "",
        CriarComposicaoCargaAutomatica: false,
        UseAcceptAutomaticOrder: false,
        NegociacaoPedido: true,
      },
    };
  }

  componentDidMount() {
    const editMode = this.props.editMode;
    const supplier = this.props.edit;

    if (editMode) {
      this.setState({
        materialSupplier: {
          ...supplier,
          QuebraEntrega: supplier.QuebraEntrega,
          Arredondamento: supplier.Arredondamento,
          LoteMinimo: supplier.LoteMinimo,
        },
        origemMaterial: supplier.Tipo,
      });
    }
  }

  updateSelectValue = (prop, value) => {
    this.setState((prevState) => ({
      materialSupplier: {
        ...prevState.materialSupplier,
        [prop]: value,
      },
    }));
  };

  changeValue = (event) => {
    const prop = event.currentTarget.name;
    let value = event.currentTarget.value;

    if (prop === "OrganizacaoCompras" || prop === "GrupoCompradores" || prop === "CodigoImposto") {
      value = value.toUpperCase();
    }

    if (prop === "SLA" || prop === "TransitTime") {
      value = formatOnlyNumber(value);
    }

    this.setState((prevState) => ({
      materialSupplier: {
        ...prevState.materialSupplier,
        [prop]: value,
      },
    }));
  };

  changeDecimalValue = (value, prop) => {
    this.setState((prevState) => ({
      materialSupplier: {
        ...prevState.materialSupplier,
        [prop]: value,
      },
    }));
  };

  save = () => {
    let { materialSupplier, origemMaterial } = this.state;
    const { ordem, idUnidadeArredondamento, descricaoUnidadeArredondamento } = this.props;

    const editMode = this.props.editMode;
    if (!editMode) {
      materialSupplier.Nome = materialSupplier.Fornecedor.Nome;
      materialSupplier.Tipo = origemMaterial;
    }

    materialSupplier.IdUnidadeArredondamento = idUnidadeArredondamento;
    materialSupplier.DescricaoUnidadeArredondamento = descricaoUnidadeArredondamento;

    const arredondamento = parseFloatByLocale(materialSupplier.Arredondamento);
    const loteMinimo = parseFloatByLocale(materialSupplier.LoteMinimo);
    const quebraEntrega = parseFloatByLocale(materialSupplier.QuebraEntrega);
    const isValidaDate = this.isValidateDataSave(
      arredondamento,
      loteMinimo,
      quebraEntrega,
      origemMaterial,
      materialSupplier
    );

    if (isValidaDate) {
      if (
        materialSupplier.ResponsavelEntrega &&
        materialSupplier.QuebraEntrega &&
        materialSupplier.Arredondamento &&
        materialSupplier.LoteMinimo &&
        (!supplierOrigin.IsTransfer(origemMaterial) || materialSupplier.OrganizacaoCompras)
      ) {
        materialSupplier.Id = -1;
        materialSupplier.Arredondamento = arredondamento;
        materialSupplier.LoteMinimo = loteMinimo;
        materialSupplier.QuebraEntrega = quebraEntrega;
        this.props.setSupplier(ordem, materialSupplier);
        this.props.handleClose();
      } else {
        this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit9"));
      }
    }
  };

  isEmptyInt = (value) => !value || value === 0;

  isValidateDataSave = (
    arredondamento,
    loteMinimo,
    quebraEntrega,
    origemMaterial,
    materialSupplier
  ) => {
    let horizonte = parseFloat(
      this.props.horizonteProgramacao ? this.props.horizonteProgramacao : 0
    );
    let leadTimeIsLngerThanTheHorizonMessage = intl.get("feedbacks.messageMaterialBusinessUnit5");

    if (this.props.useHourlyPlan) {
      horizonte = horizonte * 24;
      leadTimeIsLngerThanTheHorizonMessage = intl.get("feedbacks.messageMaterialBusinessUnit10");
    }

    if (arredondamento <= 0) {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit1"));
      return false;
    } else if (arredondamento > loteMinimo) {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit2"));
      return false;
    } else if (loteMinimo > quebraEntrega) {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit3"));
      return false;
    } else if (materialSupplier.SLA === "") {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit11"));
      return false;
    } else if (materialSupplier.TransitTime === "") {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit12"));
      return false;
    } else if (
      horizonte <
      parseFloat(materialSupplier.SLA) + parseFloat(materialSupplier.TransitTime)
    ) {
      this.props.handleFeedback(
        `${intl.get("feedbacks.messageMaterialBusinessUnit4")} ${horizonte} ${leadTimeIsLngerThanTheHorizonMessage}`
      );
      return false;
    } else if (origemMaterial === 2 && this.isEmptyInt(materialSupplier.OrganizacaoCompras)) {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit6"));
      return false;
    } else if (origemMaterial === 2 && this.isEmptyInt(materialSupplier.GrupoCompradores)) {
      this.props.handleFeedback(intl.get("feedbacks.messageMaterialBusinessUnit7"));
      return false;
    }
    return true;
  };

  changeFornecedor = (supplier) => {
    const { origemMaterial } = this.state;
    this.setState((prevState) => ({
      materialSupplier: {
        ...prevState.materialSupplier,
        IdFornecedor: supplier.Id,
        Fornecedor: supplier,
        ResponsavelEntrega: supplierOrigin.IsTransfer(origemMaterial)
          ? RESPONSAVEL_ENTREGA_FOB
          : supplier.ResponsavelEntrega,
      },
    }));
  };

  handleSelectOrigemMaterial = (value) => {
    let origemMaterial = supplierValues.COMPRA_DE_INSUMOS;

    if (supplierOrigin.IsTransfer(value)) {
      origemMaterial = supplierValues.TRANSFERENCIA;
    } else if (supplierOrigin.IsAtgPurchase(value)) {
      origemMaterial = supplierValues.COMPRA_ATG;
    } else if (supplierOrigin.IsConsigneeStock(value)) {
      origemMaterial = supplierValues.CONSIGNEE_STOCK;
    }

    this.setState((prevState) => ({
      origemMaterial,
      materialSupplier: {
        ...prevState.materialSupplier,
        IdFornecedor: 0,
        ResponsavelEntrega: supplierOrigin.IsTransfer(origemMaterial)
          ? RESPONSAVEL_ENTREGA_FOB
          : prevState.ResponsavelEntrega,
      },
    }));
  };

  converterOrdem = (ordem) => {
    switch (ordem) {
      case 0:
        return "A";
      case 1:
        return "B";
      case 2:
        return "C";
      default:
        return "D";
    }
  };

  render() {
    const { origemMaterial } = this.state;
    console.log(this.state, "teste");
    const { open, editMode, handleClose, suppliersSelecteds } = this.props;

    return (
      <StyledMaterialSupplierForm>
        <Dialog
          title={`${intl.get("commons.supplier")} ${this.converterOrdem(this.props.ordem)}`}
          contentStyle={{ width: "600px" }}
          open={open}
          autoScrollBodyContent
          actionsContainerClassName="container-action-buttons__material-supplier"
          actions={[
            <Button
              buttonType="default"
              value={intl.get("geral.buttonsDefault.cancel")}
              className="button__material_supplier"
              onClick={handleClose}
              key={1}
            />,
            <Button
              buttonType="primary"
              value={intl.get("geral.buttonsDefault.save")}
              className="button__material_supplier"
              onClick={this.save}
              key={2}
            />,
          ]}
        >
          <MaterialSupplierFormContent
            changeValue={this.changeValue}
            editMode={editMode}
            changeSupplier={this.changeFornecedor}
            materialSupplier={this.state.materialSupplier}
            suppliersSelecteds={suppliersSelecteds}
            origemMaterial={origemMaterial}
            handleSelectOrigemMaterial={this.handleSelectOrigemMaterial}
            incoterms={this.state.incoterms}
            supplier={this.props.edit}
            handleFeedback={this.props.handleFeedback}
            idLabeledFamilyCenter={this.state.idLabeledFamilyCenter}
            idLabeledFamilyCenterMaterial={this.props.idLabeledFamilyCenterMaterial}
            periodicity={this.props.periodicity}
            idMaterial={this.props.idMaterial}
            updateSelectValue={this.updateSelectValue}
            changeDecimalValue={this.changeDecimalValue}
            useHourlyPlan={this.props.useHourlyPlan}
          />
        </Dialog>
      </StyledMaterialSupplierForm>
    );
  }
}

MaterialSupplierForm.propTypes = {
  descricaoUnidadeArredondamento: PropTypes.any.isRequired,
  edit: PropTypes.object.isRequired,
  editMode: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  horizonteProgramacao: PropTypes.number.isRequired,
  idLabeledFamilyCenter: PropTypes.number.isRequired,
  idLabeledFamilyCenterMaterial: PropTypes.number,
  idMaterial: PropTypes.number.isRequired,
  idUnidadeArredondamento: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  ordem: PropTypes.number.isRequired,
  periodicity: PropTypes.any.isRequired,
  setSupplier: PropTypes.func.isRequired,
  suppliersSelecteds: PropTypes.object.isRequired,
  useHourlyPlan: PropTypes.any.isRequired,
};

export default MaterialSupplierForm;
